import {Types} from './PrestacionContext'

const ModalReducer = (state:any, action:any) => {
    const {payload,type} = action;
    
    switch(type){
        case Types.CREATE_BENEFITS:
            return {
                ...state,
                createModalBenefits:true
            }
        case Types.UPDATE_BENEFITS:
            return {
                ...state,
                _id:payload._id,
                updateModalBenefits:true
            }
      
        case Types.DELETE_BENEFITS:
            return{
                ...state,
                _id:payload._id,
                deleteModalBenefits:true
            }
        case Types.CLEAR_BENEFITS:
            return {
                ...state,
                _id: '',
                createModalBenefits: false,
                updateModalBenefits: false,
                deleteModalBenefits: false,
            }
        case Types.START_LOADING:
            return{
                ...state,
                globalLoading: true,
            }
        case Types.STOP_LOADING:
            return{
                ...state,
                globalLoading: false,
            }
        default:
        return state;
    }
}

export default ModalReducer;